export const GosseDescriptionBody = ({ bod }) => {
  return (
    <div className="description-section-two">
      For their third collection, GOSSE au CŒUR wanted to heighten the quality
      of their communication across the board – from the collection ideation and
      messages, to the apparel fabrics and graphics, to marketing collateral.
      <br />
      <br />
      The fashion brand sought to produce a collection which would evoke the
      fullness of their core identity – a kid at heart – as the brand name
      translates.
      <br />
      <br />
      The goal was to create a body of work that would further the brand’s
      agenda, challenging the audience to adopt the mindset of a dreamer,
      childlike, of one who is free.
    </div>
  );
};
